import { render, staticRenderFns } from "./DatabaseCategoryEditModal.vue?vue&type=template&id=45534c83"
import script from "./DatabaseCategoryEditModal.vue?vue&type=script&lang=js"
export * from "./DatabaseCategoryEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports